export type LeadStatus = 'hot' | 'warm' | 'cold';

/** Maps API / WebSocket classification (HOT, WARM, cold, etc.) to UI lead status. */
export function mapClassificationToLeadStatus(
  classification: string | undefined | null
): LeadStatus | null {
  const c = (classification || '').toUpperCase().trim();
  if (c === 'HOT') return 'hot';
  if (c === 'WARM') return 'warm';
  if (c === 'COLD' || c === 'COOL') return 'cold';
  return null;
}

export function mapClassificationToLeadStatusWithDefault(
  classification: string | undefined | null,
  fallback: LeadStatus = 'cold'
): LeadStatus {
  return mapClassificationToLeadStatus(classification) ?? fallback;
}
